module.exports = __webpack_public_path__ + "src/img/checker.9bd75d9e.svg";